import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Region } from 'src/app/models/Region';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  PATH_ALL_REGIONS = "/programmes-lots/regions/all-regions";
  constructor(private http: HttpClient) { }
  
  getAllRegion = (): Observable<Region[]> => {
    let url = environment.host.domaine + this.PATH_ALL_REGIONS;
    return this.http.get<Region[]>(url)
  }
}
